import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl font-semibold text-background-50">糖心影视</span>
              </Link>
              <p className="text-sm leading-relaxed text-background-50/50">
                甜蜜观影，从糖心开始。<br />
                海量高清影视资源，即点即播，<br />
                让每一次观影都成为享受。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/category/movie" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门电影</Link>
                </li>
                <li>
                  <Link to="/category/tv" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热播剧集</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-50/50">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-sm"></i>
                  </div>
                  contact@tangxinys.com
                </li>
                <li className="flex items-center gap-2 text-sm text-background-50/50">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-sm"></i>
                  </div>
                  400-888-6666
                </li>
                <li className="flex items-center gap-2 text-sm text-background-50/50">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  北京市朝阳区望京SOHO
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500/20 text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500/20 text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500/20 text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-50/40">
              &copy; 2018-2026 糖心影视 版权所有 | 京ICP备20260803001号
            </p>
            <div className="flex items-center gap-4 text-sm text-background-50/40">
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}